import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import CaseFileDownloadLink from './CaseFileDownloadLink';
import { Button, Popconfirm, Table, Typography } from 'antd';
const { Text } = Typography;

const FileTableList = ({
  dataSource,
  caseId,
  showActions = false,
  onFileDelete,
  deletePopoverName = 'file',
  fileNameIndex,
  fileObjectKeyIndex,
  fileSize,
}) => {
  const FILES_COLUMNS = useMemo(
    () => [
      {
        title: 'File Name',
        dataIndex: fileNameIndex || 'fileName',
        align: 'left',
        render: (value, record) => {
          return (
            <CaseFileDownloadLink
              caseId={caseId}
              fileName={value}
              objectKey={
                (fileObjectKeyIndex
                  ? record?.[fileObjectKeyIndex]
                  : record?.objectKey) || record?.uid
              }
            />
          );
        },
        onCell: () => {
          return { colSpan: 2 };
        },
        colSpan: 2,
      },
      {
        title: 'Size',
        dataIndex: fileSize || 'fileSize',
        align: 'right',
        ellipsis: true,
        render: (value) => {
          const KB = parseInt(value / 1024) || '-';
          return <Text style={{ textWrap: 'wrap' }}>{KB} KB</Text>;
        },
      },
      ...(showActions
        ? [
            {
              title: 'Action',
              align: 'right',
              render: (_, entity) => {
                return (
                  <Popconfirm
                    title="Delete"
                    description={`Are you sure you want to delete this ${deletePopoverName}?`}
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => onFileDelete?.(entity)}
                  >
                    <Button
                      type="text"
                      icon={<i className="fas fa-trash" />}
                      title="Delete"
                    ></Button>
                  </Popconfirm>
                );
              },
            },
          ]
        : []),
    ],
    [caseId]
  );

  return (
    <Table
      columns={FILES_COLUMNS}
      dataSource={dataSource}
      pagination={false}
      rowKey={(record) => record?.fileId || record?.uid}
    />
  );
};

FileTableList.propTypes = {
  dataSource: PropTypes.array,
  caseId: PropTypes.number,
  showActions: PropTypes.bool,
  onFileDelete: PropTypes.func,
  deletePopoverName: PropTypes.string,
  fileNameIndex: PropTypes.string,
  fileObjectKeyIndex: PropTypes.string,
  fileSize: PropTypes.string,
};

export default FileTableList;
